import { Component, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-map',
  standalone: false,
  templateUrl: './map.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    const zielonaGoraCenter: L.LatLngTuple  = [51.93548, 15.50643];
    const map = L.map('map').setView(zielonaGoraCenter, 13);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);

    L.marker(zielonaGoraCenter)
      .addTo(map)
      .bindPopup('Centrum Zielonej Góry')
      .openPopup();
  }
}